import { Auth } from "aws-amplify";

/**
 * Fix MFA delivery configuration for a user
 * This resolves the "User does not have delivery config set to turn on SOFTWARE_TOKEN_MFA" error
 */
export const fixUserMFADeliveryConfig = async (username) => {
  try {
    console.log("Attempting to fix MFA delivery config for user:", username);

    // First, try to get the current user
    const user = await Auth.currentAuthenticatedUser();
    console.log("Current user:", user);

    // Try to associate TOTP device
    try {
      const totpCode = await Auth.setupTOTP(user);
      console.log("TOTP setup successful, QR code generated");
      return {
        success: true,
        qrCode: totpCode,
        message:
          "Please scan the QR code with your authenticator app and verify with a TOTP code",
      };
    } catch (setupError) {
      console.log("TOTP setup error:", setupError);

      // If setup fails, the user might already have TOTP configured
      if (setupError.code === "InvalidParameterException") {
        // Try to set preferred MFA to TOTP
        try {
          await Auth.setPreferredMFA(user, "TOTP");
          return {
            success: true,
            message: "MFA delivery configuration updated successfully",
          };
        } catch (prefError) {
          console.log("Set preferred MFA error:", prefError);
          throw prefError;
        }
      }
      throw setupError;
    }
  } catch (error) {
    console.error("Error fixing MFA delivery config:", error);
    return {
      success: false,
      error: error.message,
      code: error.code,
    };
  }
};

/**
 * Reset user MFA configuration
 * This can be used when a user needs to reconfigure their MFA
 */
export const resetUserMFA = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();

    // Disable MFA first
    await Auth.setPreferredMFA(user, "NOMFA");
    console.log("MFA disabled for user");

    // Re-enable TOTP
    const totpCode = await Auth.setupTOTP(user);
    console.log("TOTP setup successful after reset");

    return {
      success: true,
      qrCode: totpCode,
      message: "MFA has been reset. Please scan the new QR code.",
    };
  } catch (error) {
    console.error("Error resetting MFA:", error);
    return {
      success: false,
      error: error.message,
      code: error.code,
    };
  }
};

/**
 * Check if user has MFA properly configured
 */
export const checkMFAStatus = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const mfaSettings = await Auth.getPreferredMFA(user);

    console.log("Current MFA setting:", mfaSettings);

    return {
      success: true,
      mfaEnabled: mfaSettings === "TOTP",
      currentMFA: mfaSettings,
    };
  } catch (error) {
    console.error("Error checking MFA status:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};
